import request from '@/utils/request'

/**
 * 分页查询PLUS会员订单列表
 */
export function pageList(params) {
  return request({
    url: '/plus/order/page',
    method: 'get',
    params: params
  })
}

/**
 * 查询PLUS会员订单详情
 */
export function detail(id) {
  return request({
    url: '/plus/order/detail',
    method: 'get',
    params: { id: id }
  })
}

/**
 * 取消订单
 */
export function cancelOrder(id) {
  return request({
    url: '/plus/order/cancel',
    method: 'post',
    params: { id: id }
  })
}

/**
 * 发放分销奖励
 */
export function grantCommission(id) {
  return request({
    url: '/plus/order/grantCommission',
    method: 'post',
    params: { id: id }
  })
}
